export const configDaily = [
    {name: "date", label: "Tanggal", options: {sort: false}},
    {name: "dailyCash", label: "Cash\nHarian", options: {sort: false}},
    {name: "accumulateCash", label: "Cash\nAkumulasi", options: {sort: false}},
    {name: "spCash", label: "Cash\n%sp", options: {sort: false}},
    {name: "dailyKDS", label: "KDS\nHarian", options: {sort: false}},
    {name: "accumulateKDS", label: "KDS\nAkumulasi", options: {sort: false}},
    {name: "spKDS", label: "KDS\n%sp", options: {sort: false}},
    {name: "dailyCredit", label: "Kredit\nHarian", options: {sort: false}},
    {name: "spCredit", label: "Kredit\n%sp", options: {sort: false}},
    {name: "accumulateCredit", label: "Kredit\nAkumulasi", options: {sort: false}},
    {name: "dailyTotal", label: "Total\nHarian", options: {sort: false}},
    {name: "accumulateTotal", label: "Total\nAkumulasi", options: {sort: false}},
];

export const configMonthToDateCabang = [
    {name: "name", label: "Cabang", options: {sort: false,}},
    {name: "lastMonth", label: "Last Month", options: {sort: false,}},
    {name: "thisMonth", label: "This Month", options: {sort: true,}},
    {name: "growth", label: "Growth", options: {sort: true,customBodyRender: (val) => (val!== null ? `${val}%` : null)}},
    {name: "forecasting", label: "Proyeksi", options: {sort: false,}},
];